// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Subscription_main_nav__xsEys {
  display: flex;
  margin: 2rem 0;
  border-bottom: solid 1px var(--color-dark);
  gap: 2rem;
  width: fit-content;
}
.Subscription_main_nav_item__tC3gI {
  cursor: pointer;
  padding: 1rem 0;
  font-size: var(--default-font-small);
}
.Subscription_main_nav_item_active__x30kS {
  cursor: pointer;
  padding: 1rem 0;
  font-weight: 700;
  border-bottom: solid 2px var(--color-dark);
}
.Subscription_main_nav_item__tC3gI:hover, .Subscription_main_nav_item__tC3gI:focus, .Subscription_main_nav_item__tC3gI:focus-visible, .Subscription_main_nav_item__tC3gI:focus-within {
  font-weight: 700;
}

.Subscription_metrics__WcZRN {
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;
  width: 100%;
}
.Subscription_metrics__WcZRN :last-child {
  margin-bottom: 2rem;
}
@media only screen and (max-width: 600px) {
  .Subscription_metrics__WcZRN {
    display: grid;
    grid-template-columns: 50% 50%;
  }
}
.Subscription_metrics__searchFilter__DxzSE {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 5.6rem;
}

.Subscription_active__feGN- {
  width: 30rem;
  background-color: var(--color-primary-3);
}
.Subscription_active__feGN-:hover {
  background-color: var(--color-primary-7);
}

.Subscription_expired__8FII9 {
  width: 30rem;
  background-color: var(--color-error);
  color: var(--color-white);
}
.Subscription_expired__8FII9:hover {
  background-color: var(--color-deep-red);
}

.Subscription_due__Du0Z5 {
  width: 30rem;
  background-color: var(--color-yellow-2);
}
.Subscription_due__Du0Z5:hover {
  background-color: var(--color-yellow);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Subscription/Subscription.module.scss"],"names":[],"mappings":"AAGC;EACC,aAAA;EACA,cAAA;EACA,0CAAA;EACA,SAAA;EACA,kBAAA;AAFF;AAIE;EACC,eAAA;EACA,eAAA;EACA,oCAAA;AAFH;AAIG;EACC,eAAA;EACA,eAAA;EACA,gBAAA;EACA,0CAAA;AAFJ;AAKG;EAIC,gBAAA;AANJ;;AAYA;EACC,aAAA;EACA,SAAA;EACA,mBAAA;EACA,WAAA;AATD;AAWC;EACC,mBAAA;AATF;AAYC;EAVD;IAWE,aAAA;IACA,8BAAA;EATA;AACF;AAWC;EACC,aAAA;EACA,uBAAA;EACA,WAAA;EACA,kBAAA;AATF;;AAaA;EACC,YAAA;EACA,wCAAA;AAVD;AAYC;EACC,wCAAA;AAVF;;AAcA;EACC,YAAA;EACA,oCAAA;EACA,yBAAA;AAXD;AAaC;EACC,uCAAA;AAXF;;AAeA;EACC,YAAA;EACA,uCAAA;AAZD;AAcC;EACC,qCAAA;AAZF","sourcesContent":["@import '../variables/breakpoints';\n\n.main {\n\t&_nav {\n\t\tdisplay: flex;\n\t\tmargin: 2rem 0;\n\t\tborder-bottom: solid 1px var(--color-dark);\n\t\tgap: 2rem;\n\t\twidth: fit-content;\n\n\t\t&_item {\n\t\t\tcursor: pointer;\n\t\t\tpadding: 1rem 0;\n\t\t\tfont-size: var(--default-font-small);\n\n\t\t\t&_active {\n\t\t\t\tcursor: pointer;\n\t\t\t\tpadding: 1rem 0;\n\t\t\t\tfont-weight: 700;\n\t\t\t\tborder-bottom: solid 2px var(--color-dark);\n\t\t\t}\n\n\t\t\t&:hover,\n\t\t\t&:focus,\n\t\t\t&:focus-visible,\n\t\t\t&:focus-within {\n\t\t\t\tfont-weight: 700;\n\t\t\t}\n\t\t}\n\t}\n}\n\n.metrics {\t\t\n\tdisplay: flex;\t\n\tgap: 1rem;\n\tmargin-bottom: 1rem;\n\twidth: 100%;\n\n\t:last-child {\n\t\tmargin-bottom: 2rem;\n\t}\n\t\n\t@media only screen and (max-width: 600px) {\n\t\tdisplay: grid;\n\t\tgrid-template-columns: 50% 50%;\t\n\t}\n\t\n\t&__searchFilter {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\twidth: 100%;\n\t\tmargin-top: 5.6rem;\n\t}\n}\n\n.active {\n\twidth: 30rem;\n\tbackground-color: var(--color-primary-3);\n\n\t&:hover {\n\t\tbackground-color: var(--color-primary-7);\n\t}\n}\n\n.expired {\n\twidth: 30rem;\n\tbackground-color: var(--color-error);\n\tcolor: var(--color-white);\n\n\t&:hover {\n\t\tbackground-color: var(--color-deep-red);\n\t}\n\t\n}\n.due {\n\twidth: 30rem;\n\tbackground-color: var(--color-yellow-2);\n\n\t&:hover {\n\t\tbackground-color: var(--color-yellow);\t\t\n\t}\t\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main_nav": `Subscription_main_nav__xsEys`,
	"main_nav_item": `Subscription_main_nav_item__tC3gI`,
	"main_nav_item_active": `Subscription_main_nav_item_active__x30kS`,
	"metrics": `Subscription_metrics__WcZRN`,
	"metrics__searchFilter": `Subscription_metrics__searchFilter__DxzSE`,
	"active": `Subscription_active__feGN-`,
	"expired": `Subscription_expired__8FII9`,
	"due": `Subscription_due__Du0Z5`
};
export default ___CSS_LOADER_EXPORT___;
